import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { LiveStreamInfo } from '../modal';

export default function reducer(state: LiveStreamInfo = new LiveStreamInfo(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.LIVE_STREAMING_INFO_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.LIVE_STREAMING_INFO_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.LIVE_STREAMING_INFO_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
